import React from 'react';
import './isi.scss';
import IsiListItem from './IsiListItem';

function IsiList({ item, wrap, index, sub }) {
  return (
    <ul className={wrap ? 'isi__body__ul--wrap' : 'isi__body__ul'}>
      {item.map((listItem, i) => {
        return <IsiListItem el={listItem} key={`listItem-${index}-${i}`} sub={sub} />;
      })}
    </ul>
  );
}

export default IsiList;
